import { Injectable } from '@angular/core';
import { EvolutionChartsPayload } from './evolution-charts-data';

const STORAGE_KEY = 'evolutionChartsCache';

/**
 * Cache del último payload por clave de parámetros.
 * Persiste en sessionStorage para que al abrir la misma URL en ventana nueva se muestren las gráficas de inmediato.
 */
@Injectable({ providedIn: 'root' })
export class EvolutionChartsCacheService {
  private cache: Map<string, EvolutionChartsPayload> = new Map();

  get(key: string): EvolutionChartsPayload | null {
    const fromMemory = this.cache.get(key) ?? null;
    if (fromMemory) return fromMemory;
    try {
      const raw = typeof sessionStorage !== 'undefined' ? sessionStorage.getItem(STORAGE_KEY) : null;
      if (!raw) return null;
      const { key: storedKey, payload } = JSON.parse(raw) as { key: string; payload: EvolutionChartsPayload };
      if (storedKey !== key) return null;
      this.cache.set(key, payload);
      return payload;
    } catch {
      return null;
    }
  }

  set(key: string, payload: EvolutionChartsPayload): void {
    this.cache.set(key, payload);
    try {
      if (typeof sessionStorage !== 'undefined') {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ key, payload }));
      }
    } catch {
      // ignore quota or serialization errors
    }
  }

  /** Genera clave estable a partir de los params de la ruta. */
  static cacheKey(params: Record<string, string | number | null | undefined>): string {
    return JSON.stringify({
      patientId: params['patientId'] ?? '',
      labNr: params['labNr'] ?? 0,
      referenceDate: params['referenceDate'] ?? '',
      requisType: params['requisType'] ?? 0,
      testList: params['testList'] ?? '',
      centroId: params['centroId'] ?? '',
    });
  }
}
